import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

// Abas internas do módulo Flowbuilder (mockup "Frases A"): Fluxos ·
// Frases gatilho · Fluxo padrão. Substitui o submenu da sidebar. `counts`
// mostra "· N" na aba correspondente.
const useStyles = makeStyles((theme) => ({
  tabsBar: { display: "flex", gap: 2, flexShrink: 0 },
  tab: {
    appearance: "none",
    background: "none",
    border: "none",
    borderBottom: "2px solid transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    padding: "8px 14px",
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
    "&:hover": { color: theme.palette.text.primary },
  },
  tabActive: {
    color: theme.palette.text.primary,
    borderBottom: "2px solid",
    borderImage: `linear-gradient(90deg,${theme.palette.primary.main},#22D3EE) 1`,
  },
  count: { color: theme.palette.text.secondary, fontWeight: 500 },
}));

export const FLOW_TABS = [
  { to: "/flowbuilders", labelKey: "aeros.flow.tabs.flows", key: "flows" },
  { to: "/phrase-lists", labelKey: "aeros.flow.tabs.phrases", key: "phrases" },
  { to: "/flow-default", labelKey: "aeros.flow.tabs.defaults", key: "defaults" },
];

const FlowBuilderNav = ({ counts = {} }) => {
  const classes = useStyles();
  const history = useHistory();
  const { pathname } = useLocation();
  const isActive = (to) => pathname === to || pathname.startsWith(`${to}/`);
  return (
    <nav className={classes.tabsBar} aria-label={i18n.t("aeros.flow.title")}>
      {FLOW_TABS.map(({ to, labelKey, key }) => (
        <button
          key={to}
          type="button"
          className={`${classes.tab} ${isActive(to) ? classes.tabActive : ""}`}
          aria-current={isActive(to) ? "page" : undefined}
          onClick={() => history.push(to)}
        >
          {i18n.t(labelKey)}
          {counts[key] != null && <span className={classes.count}> · {counts[key]}</span>}
        </button>
      ))}
    </nav>
  );
};

export default FlowBuilderNav;
